<template>
	<section class="hero is-fullheight">
		<div class="hero-body">
			<div class="container">
				<div class="columns is-centered">
					<div class="column is-5-tablet is-4-desktop is-3-widescreen">
						<Logo/>
						<form @submit.prevent="logIn" class="box">
							<h2 v-if="appliCourante" class="title">{{appliCourante.title}}</h2>
							<h2 class="subtitle">Connexion</h2>
							<p>Connectez-vous avec votre identifiant SO GEST. Si vous n'avez pas encore de compte, <a href="https://admin.sopress.net/sogest/personnel.php">suivez ce lien pour le créer</a></p>
							<div class="field">
								<label for="" class="label">Email</label>
								<div class="control has-icons-left">
									<input v-model="login.email" type="text" placeholder="giovanni.seri@sopress.net" class="input" required>
									<span class="icon is-small is-left">
										<i class="fa fa-envelope"></i>
									</span>
								</div>
							</div>
							<div class="field">
								<label for="" class="label">Mot de passe</label>
								<div class="control has-icons-left">
									<input v-model="login.pass" type="password" placeholder="*******" class="input" required>
									<span class="icon is-small is-left">
										<i class="fa fa-lock"></i>
									</span>
								</div>
								<p><a href="https://admin.sopress.net/sogest/mot-de-passe.php">Mot de passe perdu ?</a></p>
							</div>
							<div class="field">
								<button class="button is-warning" :class="loading ? 'is-loading' : ''">
									Se connecter
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</section>	
</template>
<script>
	export default {
		data() {
			return {
				loading:false,
				login: {
					email:process.env.VUE_APP_LOGIN,
					pass:process.env.VUE_APP_PASS
				}
			}
		},
		mounted() {
		},
		methods: {
			logIn() {
				this.loading=true;
				axios.post('jwt',{login:this.login}).then(response => {
					setTimeout(() => {
						this.loading=false;
						if(response.data.jwt) {
							this.$store.commit('setJwt',response.data.jwt);
						} else {
							alert('Identifiant ou mot de passe invalide');
						}
					},1000)
				});
			}
		}
	}
</script>